import { useTranslation } from 'react-i18next';

export type CourierFileStatus = 'all' | 'imported' | 'processed' | 'error';

interface StatusTab {
    key: CourierFileStatus;
    label: string;
}

export interface StatusToolbarProps {
    activeStatus: CourierFileStatus;
    onStatusChange: (status: CourierFileStatus) => void;
}

export const StatusToolbar = ({
    activeStatus,
    onStatusChange,
}: StatusToolbarProps) => {
    const { t } = useTranslation('codCourierFiles');

    const tabs: StatusTab[] = [
        { key: 'all', label: t('tabs.all', 'Todos') },
        { key: 'imported', label: t('tabs.imported', 'Importados') },
        { key: 'processed', label: t('tabs.processed', 'Procesados') },
        { key: 'error', label: t('tabs.error', 'Con errores') },
    ];

    return (
        <div
            className="flex bg-card-bg rounded-lg text-sm p-1 mb-4 overflow-x-auto scrollbar-hide light:border-card-border light:border"
            style={{ WebkitOverflowScrolling: 'touch' }}
        >
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onStatusChange(tab.key)}
                    className={`px-3 py-1 rounded hover:bg-hover-press whitespace-nowrap transition-colors ${activeStatus === tab.key ? 'bg-hover-press' : ''
                        }`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

